import { Component, Vue, Prop } from "vue-property-decorator";
import { Spin, Icon } from "ant-design-vue";

@Component({
	components: {
		Spin,
		Icon
	}
})
export default class Spinning extends Vue {
	@Prop({ default: false }) spinning: boolean | undefined;
	@Prop({ default: "30" }) size?: string | undefined;
	@Prop({ default: 500 }) delay?: number | undefined;

	get fontSize() {
		return `font-size: ${this.size}px`;
	}
}
